import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import {CountUp} from "countup.js/dist/countUp.min";

export class AuwAnimatedCounter extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    __PageReady(){
        this.$el.get(0).addEventListener('auw-ce-entered-viewport', this.animateIt.bind(this));
    }

    animateIt(){
        let hasDecimals = this.config.numberFrom % 1 !== 0 || this.config.numberTo % 1 !== 0;

        const options = {
            startVal: hasDecimals ? this.config.numberFrom : parseInt(this.config.numberFrom),
            decimalPlaces: hasDecimals ? 2 : 0,
            duration: this.config.duration,
            useGrouping: false,
            decimal: this.config.decimalSeperator,
        };
        let countup = new CountUp(this.$el.find('.number_counter').get(0), this.config.numberTo, options);
        if (!countup.error) {
            countup.start();
        }
    }
}